export const possibleItems = [
  {
    text: 'Коммунальные платежи',
    value: 'utilityCharges',
  },
  {
    text: 'Эксплуатационные расходы',
    value: 'operationalCosts',
  },
];

export const operationalCostsOptions = [
  {
    text: 'Включены',
    value: true,
  },
  {
    text: 'Не предусмотрены',
    value: false,
  },
];

export default [
  {
    text: 'Включены коммунальные платежи',
    value: 'utilityCharges',
  },
  {
    text: 'Включены эксплуатационные расходы',
    value: 'operationalCosts',
  },
];
